// extracted by mini-css-extract-plugin
export default {"field":"ListMoveStep_field__I0x8s","text":"ListMoveStep_text__-f+C7"};